export const NAME_SPACE = 'systemSettings.grid-and-system-protection-configuration.reactive-power-settings'
